import { t, useLocale } from '../localization/adminText';
import { Badge, BlockStack, Button, InlineStack, Text } from './admin-ui';

export function orderRowClass(order) {
  const membership = order.list_membership;
  const risk = order.risk_assessment;
  const blacklisted = membership?.status === 'ready' && (membership.ip_blacklisted || membership.customer_blacklisted);
  let tone = blacklisted ? 'critical' : ['ready', 'unavailable'].includes(risk?.status) ? risk.row_tone : null;
  if (!blacklisted && !risk && membership?.status === 'ready') tone = membership.row_tone;
  if (tone === 'success' && risk && (risk.status !== 'ready' || risk.details_incomplete || !['low', 'none'].includes(risk.level))) tone = null;
  return ['critical', 'warning', 'success'].includes(tone) ? `cod-order-row cod-order-row--${tone}` : 'cod-order-row';
}

export function CodOrderListState({ order }) {
  useLocale();
  const state = order.list_membership;
  if (state?.status === 'not_applicable') return null;
  if (state?.status !== 'ready') return <Text as="p" tone="subdued">{t('Current list status is unavailable. Refresh before changing rules.')}</Text>;
  const labels = [
    [state.ip_blacklisted, 'IP blacklisted', 'critical'],
    [state.phone_blacklisted, 'Phone blacklisted', 'critical'],
    [state.email_blacklisted, 'Email blacklisted', 'critical'],
    [state.email_domain_blacklisted, 'Email domain rule matched', 'critical'],
    [state.ip_whitelisted, 'IP whitelisted', 'info'],
  ].filter(([matched]) => matched);
  return <BlockStack gap="200">
    <Text as="h3" variant="headingSm">{t('Current list status')}</Text>
    {labels.length ? <InlineStack gap="200">{labels.map(([, label, tone]) => <Badge key={label} tone={tone}>{t(label)}</Badge>)}</InlineStack>
      : <Text as="p" tone="subdued">{t('No active blacklist or IP whitelist match.')}</Text>}
    {state.customer_partially_blacklisted && <Text as="p">{t('Only some contact details are covered. Any matched blacklist rule can block a new order.')}</Text>}
    <Text as="p" tone="subdued">{t('Current rules apply to new orders and do not cancel this order.')}</Text>
  </BlockStack>;
}

export function CodBlacklistButtons({ order, pending = {}, onAdd }) {
  useLocale();
  const state = order.list_membership;
  if (order.can_manage_source === false || state?.can_manage === false) return null;
  const ready = state?.status === 'ready';
  const ipAdded = ready && state.ip_blacklisted;
  const customerAdded = ready && state.customer_fully_blacklisted;
  return <>
    {order.ip && <Button tone={ipAdded ? undefined : 'critical'} disabled={!ready || ipAdded} loading={!!pending[`ip:${order.id}`]} onClick={() => onAdd(order, 'ip')}>
      {t(ipAdded ? 'IP already blacklisted' : 'Blacklist IP')}
    </Button>}
    {(order.phone || order.email) && <Button tone={customerAdded ? undefined : 'critical'} disabled={!ready || customerAdded} loading={!!pending[`customer:${order.id}`]} onClick={() => onAdd(order, 'customer')}>
      {t(customerAdded ? 'Customer already blacklisted' : state?.customer_partially_blacklisted ? 'Blacklist remaining contact details' : 'Blacklist customer')}
    </Button>}
  </>;
}
